
import moment from "moment";

export const backdatedParamsSet=(data:any)=>{
    return data?.final_response
}

export const backdatedParamsSet1=(data:any)=>{
    if(data=== undefined || data?.targetStoploss === undefined || data?.targetStoploss === null){
        return []
    }
    else{
        let arr:any[]       = [];
        let tsl_arr:any[]   = [];
        arr[0]={
                 s_symbol        : data?.asset,
                 model_type      : getModelWiseParams(data?.identifier?.slice(0,-1)),
                 s_code       :data?.identifier,
                 dt_exit_time     :data?.dt_end_time,
                 dt_open_time    :data?.dt_open_time,
                 option_type     :data?.option_type,
                 strike_price    :data?.strike_price,
                 dt_expiry_date  :data?.dt_expiry_date === null || undefined ? ' ' : data?.dt_expiry_date,
                 open_date       :moment(data?.open_date).format("YYYY-MM-DD"),
                 trade_close_date:data?.s_reason === ''? '' : data?.trade_close_date,
                 s_status :     (data?.s_reason === null || data?.s_reason === undefined)?'':data?.s_reason,
                j_dividend_array : data?.j_dividend_list,
                unique_id:data?.unique_id

               }
               
        const TargetStoploss = Object.keys(data?.targetStoploss);
         TargetStoploss?.map((item:any)=>{
             let target          = data?.targetStoploss[item]?.Target;
             let stoploss        = data?.targetStoploss[item]?.Stoploss;
             let time            = item;                                                              

             if(target !== undefined && stoploss !== undefined){
                tsl_arr.unshift({target,stoploss,time})
                return;
             }
             if(target !== undefined){
                tsl_arr.unshift({target,time})
                return;


             }
             if(stoploss !== undefined){
                tsl_arr.unshift({stoploss,time})
                return;


             }
             
         })
        arr[0] = {...arr[0],tsl_arr}
         
         return arr
    }
}

export function getModelWiseParams(identifier:string){ //new added
   
    const modelObject:any ={ //new added
        'AIONIFABI': 'N50 OpS-M1',
        'QIONIFSMI': 'N50 OpS-M2',
        'AIONIFMMI': 'N50 OpS-M3',
        'AIONIFDDI': 'N50 OpS-LFT',
        'AIOBANDDI': 'NB OpS-LFT',
        'AIONIFKKI': 'N50 OpL-M1',
        'AIOBANABI': 'N OpS-M1',
        'QIONIFSMI-15':'N50 OpS-M2.15',
        'QIONIFSMI-17':'N50 OpS-M2.17',
        'QIONIFSMI-19':'N50 OpS-M2.19',
        'QIONIFSMI-21':'N50 OpS-M2.21',
        'QIONIFSMI-23':'N50 OpS-M2.23',
        'QIONIFSMI-25':'N50 OpS-M2.25',
        'QIONIFSMI-27':'N50 OpS-M2.27',
        'QIONIFSMI-29':'N50 OpS-M2.29',
        'QIONIFSMI-31':'N50 OpS-M2.31',
        'QIONIFSMI-33':'N50 OpS-M2.33',
        'QIONIFSMI-35':'N50 OpS-M2.35',
        'QIONIFSMI-37':'N50 OpS-M2.37',
        'QIONIFSMI-39':'N50 OpS-M2.39',
        'QIONIFSMI-41':'N50 OpS-M2.41',
        'QIONIFSMI-43':'N50 OpS-M2.43',
        'QIONIFSMI-45':'N50 OpS-M2.45',
        'QIONIFSMI-47':'N50 OpS-M2.47',
        'QIONIFSMI-49':'N50 OpS-M2.49',
        'QIONIFSMI-51':'N50 OpS-M2.51',
        'QIONIFSMI-53':'N50 OpS-M2.53',
        'QIONIFSMI-55':'N50 OpS-M2.55',
        'QIONIFSMI-57':'N50 OpS-M2.57',
        'QIONIFSMI-59':'N50 OpS-M2.59',
        'QIONIFSMI-01':'N50 OpS-M2.01',
        'QIONIFSMI-03':'N50 OpS-M2.03',
        'QIONIFSMI-05':'N50 OpS-M2.05',
        'QIONIFSMI-07':'N50 OpS-M2.07',
        'QIONIFSMI-09':'N50 OpS-M2.09',
        'QIONIFSMI-11':'N50 OpS-M2.11',
        'QIONIFSMI-13':'N50 OpS-M2.13',
        'QIONIFSRI-15':'N50 OpS-M3.15',
        'QIONIFSRI-17':'N50 OpS-M3.17',
        'QIONIFSRI-19':'N50 OpS-M3.19',
        'QIONIFSRI-21':'N50 OpS-M3.21',
        'QIONIFSRI-23':'N50 OpS-M3.23',
        'QIONIFSRI-25':'N50 OpS-M3.25',
        'QIONIFSRI-27':'N50 OpS-M3.27',
        'QIONIFSRI-29':'N50 OpS-M3.29',
        'QIONIFSRI-31':'N50 OpS-M3.31',
        'QIONIFSRI-33':'N50 OpS-M3.33',
        'QIONIFSRI-35':'N50 OpS-M3.35',
        'QIONIFSRI-37':'N50 OpS-M3.37',
        'QIONIFSRI-39':'N50 OpS-M3.39',
        'QIONIFSRI-41':'N50 OpS-M3.41',
        'QIONIFSRI-43':'N50 OpS-M3.43',
        'QIONIFSRI-45':'N50 OpS-M3.45',
        'QIONIFSRI-47':'N50 OpS-M3.47',
        'QIONIFSRI-49':'N50 OpS-M3.49',
        'QIONIFSRI-51':'N50 OpS-M3.51',
        'QIONIFSRI-53':'N50 OpS-M3.53',
        'QIONIFSRI-55':'N50 OpS-M3.55',
        'QIONIFSRI-57':'N50 OpS-M3.57',
        'QIONIFSRI-59':'N50 OpS-M3.59',
        'QIONIFSRI-01':'N50 OpS-M3.01',
        'QIONIFSRI-03':'N50 OpS-M3.03',
        'QIONIFSRI-05':'N50 OpS-M3.05',
        'QIONIFSRI-07':'N50 OpS-M3.07',
        'QIONIFSRI-09':'N50 OpS-M3.09',
        'QIONIFSRI-11':'N50 OpS-M3.11',
        'QIONIFSRI-13':'N50 OpS-M3.13',
        'AIONIFABI-16':'N50 OpS-M1.16',
        'AIONIFABI-18':'N50 OpS-M1.18',
        'AIONIFABI-20':'N50 OpS-M1.20',
        'AIONIFABI-22':'N50 OpS-M1.22',
        'AIONIFABI-24':'N50 OpS-M1.24',
        'AIONIFABI-26':'N50 OpS-M1.26',
        'AIONIFABI-28':'N50 OpS-M1.28',
        'AIONIFABI-30':'N50 OpS-M1.30',
        'AIONIFABI-32':'N50 OpS-M1.32',
        'AIONIFABI-34':'N50 OpS-M1.34',
        'AIONIFABI-36':'N50 OpS-M1.36',
        'AIONIFABI-38':'N50 OpS-M1.38',
        'AIONIFABI-40':'N50 OpS-M1.40',
        'AIONIFABI-42':'N50 OpS-M1.42',
        'AIONIFABI-44':'N50 OpS-M1.44',
        'AIONIFABI-46':'N50 OpS-M1.46',
        'AIONIFABI-48':'N50 OpS-M1.48',
        'AIONIFABI-50':'N50 OpS-M1.50',
        'AIONIFABI-52':'N50 OpS-M1.52',
        'AIONIFABI-54':'N50 OpS-M1.54',
        'AIONIFABI-56':'N50 OpS-M1.56',
        'AIONIFABI-58':'N50 OpS-M1.58',
        'AIONIFABI-00':'N50 OpS-M1.00',
        'AIONIFABI-02':'N50 OpS-M1.02',
        'AIONIFABI-04':'N50 OpS-M1.04',
        'AIONIFABI-06':'N50 OpS-M1.06',
        'AIONIFABI-08':'N50 OpS-M1.08',
        'AIONIFABI-10':'N50 OpS-M1.10',
        'AIONIFABI-12':'N50 OpS-M1.12',
        'AIONIFABI-14':'N50 OpS-M1.14',
        'AIONIFABI-15':'N50 OpS-M1.15'



    }
    if(Object.keys(modelObject)?.includes(identifier)){
        // console.log("${modelObject[identifier]}",modelObject[identifier]);
        
        return `${modelObject[identifier]}`
    }
    else{
        return ' '
    }
}


export function getModelWiseParamsHistoricalHeatmap(identifier:string){ 
   
    const modelObject:any ={ 
        'AIONIFABI': 'N50 OpS-M1',
        'QIONIFSMI': 'N50 OpS-M2',
        'QIONIFSRI': 'N50 OpS-M3',
        'AIONIFDDI': 'N50 OpS-LFT',
        'AIOBANDDI': 'NB OpS-LFT',
        'AIONIFKKI': 'N50 OpL-M1',
        'AIOBANABI': 'N OpS-M1',
        'QIONIFSMI-15':'N50 OpS-M2.15',
        'QIONIFSMI-17':'N50 OpS-M2.17',
        'QIONIFSMI-19':'N50 OpS-M2.19',
        'QIONIFSMI-21':'N50 OpS-M2.21',
        'QIONIFSMI-23':'N50 OpS-M2.23',
        'QIONIFSMI-25':'N50 OpS-M2.25',
        'QIONIFSMI-27':'N50 OpS-M2.27',
        'QIONIFSMI-29':'N50 OpS-M2.29',
        'QIONIFSMI-31':'N50 OpS-M2.31',
        'QIONIFSMI-33':'N50 OpS-M2.33',
        'QIONIFSMI-35':'N50 OpS-M2.35',
        'QIONIFSMI-37':'N50 OpS-M2.37',
        'QIONIFSMI-39':'N50 OpS-M2.39',
        'QIONIFSMI-41':'N50 OpS-M2.41',
        'QIONIFSMI-43':'N50 OpS-M2.43',
        'QIONIFSMI-45':'N50 OpS-M2.45',
        'QIONIFSMI-47':'N50 OpS-M2.47',
        'QIONIFSMI-49':'N50 OpS-M2.49',
        'QIONIFSMI-51':'N50 OpS-M2.51',
        'QIONIFSMI-53':'N50 OpS-M2.53',
        'QIONIFSMI-55':'N50 OpS-M2.55',
        'QIONIFSMI-57':'N50 OpS-M2.57',
        'QIONIFSMI-59':'N50 OpS-M2.59',
        'QIONIFSMI-01':'N50 OpS-M2.01',
        'QIONIFSMI-03':'N50 OpS-M2.03',
        'QIONIFSMI-05':'N50 OpS-M2.05',
        'QIONIFSMI-07':'N50 OpS-M2.07',
        'QIONIFSMI-09':'N50 OpS-M2.09',
        'QIONIFSMI-11':'N50 OpS-M2.11',
        'QIONIFSMI-13':'N50 OpS-M2.13',
        'QIONIFSRI-15':'N50 OpS-M3.15',
        'QIONIFSRI-17':'N50 OpS-M3.17',
        'QIONIFSRI-19':'N50 OpS-M3.19',
        'QIONIFSRI-21':'N50 OpS-M3.21',
        'QIONIFSRI-23':'N50 OpS-M3.23',
        'QIONIFSRI-25':'N50 OpS-M3.25',
        'QIONIFSRI-27':'N50 OpS-M3.27',
        'QIONIFSRI-29':'N50 OpS-M3.29',
        'QIONIFSRI-31':'N50 OpS-M3.31',
        'QIONIFSRI-33':'N50 OpS-M3.33',
        'QIONIFSRI-35':'N50 OpS-M3.35',
        'QIONIFSRI-37':'N50 OpS-M3.37',
        'QIONIFSRI-39':'N50 OpS-M3.39',
        'QIONIFSRI-41':'N50 OpS-M3.41',
        'QIONIFSRI-43':'N50 OpS-M3.43',
        'QIONIFSRI-45':'N50 OpS-M3.45',
        'QIONIFSRI-47':'N50 OpS-M3.47',
        'QIONIFSRI-49':'N50 OpS-M3.49',
        'QIONIFSRI-51':'N50 OpS-M3.51',
        'QIONIFSRI-53':'N50 OpS-M3.53',
        'QIONIFSRI-55':'N50 OpS-M3.55',
        'QIONIFSRI-57':'N50 OpS-M3.57',
        'QIONIFSRI-59':'N50 OpS-M3.59',
        'QIONIFSRI-01':'N50 OpS-M3.01',
        'QIONIFSRI-03':'N50 OpS-M3.03',
        'QIONIFSRI-05':'N50 OpS-M3.05',
        'QIONIFSRI-07':'N50 OpS-M3.07',
        'QIONIFSRI-09':'N50 OpS-M3.09',
        'QIONIFSRI-11':'N50 OpS-M3.11',
        'QIONIFSRI-13':'N50 OpS-M3.13',
        'AIONIFABI-16':'N50 OpS-M1.16',
        'AIONIFABI-18':'N50 OpS-M1.18',
        'AIONIFABI-20':'N50 OpS-M1.20',
        'AIONIFABI-22':'N50 OpS-M1.22',
        'AIONIFABI-24':'N50 OpS-M1.24',
        'AIONIFABI-26':'N50 OpS-M1.26',
        'AIONIFABI-28':'N50 OpS-M1.28',
        'AIONIFABI-30':'N50 OpS-M1.30',
        'AIONIFABI-32':'N50 OpS-M1.32',
        'AIONIFABI-34':'N50 OpS-M1.34',
        'AIONIFABI-36':'N50 OpS-M1.36',
        'AIONIFABI-38':'N50 OpS-M1.38',
        'AIONIFABI-40':'N50 OpS-M1.40',
        'AIONIFABI-42':'N50 OpS-M1.42',
        'AIONIFABI-44':'N50 OpS-M1.44',
        'AIONIFABI-46':'N50 OpS-M1.46',
        'AIONIFABI-48':'N50 OpS-M1.48',
        'AIONIFABI-50':'N50 OpS-M1.50',
        'AIONIFABI-52':'N50 OpS-M1.52',
        'AIONIFABI-54':'N50 OpS-M1.54',
        'AIONIFABI-56':'N50 OpS-M1.56',
        'AIONIFABI-58':'N50 OpS-M1.58',
        'AIONIFABI-00':'N50 OpS-M1.00',
        'AIONIFABI-02':'N50 OpS-M1.02',
        'AIONIFABI-04':'N50 OpS-M1.04',
        'AIONIFABI-06':'N50 OpS-M1.06',
        'AIONIFABI-08':'N50 OpS-M1.08',
        'AIONIFABI-10':'N50 OpS-M1.10',
        'AIONIFABI-12':'N50 OpS-M1.12',
        'AIONIFABI-14':'N50 OpS-M1.14',
        'AIONIFABI-15':'N50 OpS-M1.15'
    }
    if(Object.keys(modelObject)?.includes(identifier)){
        return `${modelObject[identifier]}`
    }
    else{
        return ' '
    }
}






